import { useState } from "react";
import type { Movie } from "@/types";

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  movie: Movie;
}

export default function ShareModal({ open, onClose, movie }: ShareModalProps) {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const channels = [
    { icon: "ri-wechat-line", label: "微信" },
    { icon: "ri-weibo-line", label: "微博" },
    { icon: "ri-qq-line", label: "QQ" },
    { icon: "ri-link", label: "复制链接" },
  ];

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/50 px-4" onClick={onClose}>
      <div
        className="w-full max-w-sm rounded-lg border border-background-200 bg-background-50 p-6 animate-fade-up"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-base font-bold text-foreground-950">分享《{movie.title}》</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭分享弹窗"
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <p className="mt-2 text-xs text-foreground-500">
          复制链接，把这部好作品分享给同样喜欢影视的朋友。
        </p>

        <div className="mt-5 grid grid-cols-4 gap-3">
          {channels.map((channel) => (
            <button
              key={channel.label}
              type="button"
              onClick={handleCopy}
              className="flex flex-col items-center gap-2 rounded-md py-2 transition-colors hover:bg-background-100 cursor-pointer"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${channel.icon} text-xl`}></i>
              </span>
              <span className="text-[11px] text-foreground-600">{channel.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-5 flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
          <i className="ri-links-line shrink-0 text-foreground-400"></i>
          <span className="min-w-0 flex-1 truncate text-xs text-foreground-500">
            {typeof window !== "undefined" ? window.location.href : ""}
          </span>
          <button
            type="button"
            onClick={handleCopy}
            className="shrink-0 whitespace-nowrap rounded-md bg-accent-500 px-3 py-1.5 text-xs font-semibold text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
          >
            {copied ? "已复制" : "复制"}
          </button>
        </div>
      </div>
    </div>
  );
}